import { ReactNode, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { client } from '@/core/graphql/ApolloClient/apolloClient';
import { useTrackPageView } from '@/core/tracking/_hooks/useTrackPageView';
import { useClearClientAuthData } from '@/features/Auth/_utils/useClearClientAuthData';

import { useIdToken } from '../../store/auth/authSelectors';
import { paths } from '../paths';

type Props = {
	children: ReactNode;
	isAllowed?: boolean;
};

// AWS Cognito auth service
export const PrivateRoute = ({ children, isAllowed = true }: Props) => {
	const idToken = useIdToken();
	const { clearClientAuthData } = useClearClientAuthData();

	useTrackPageView({ skip: !idToken });

	useEffect(() => {
		if (!idToken) {
			clearClientAuthData();
			void client.clearStore();
		}
	}, [idToken, clearClientAuthData]);

	if (!idToken) {
		return <Navigate to={paths.login} replace />;
	}

	if (!isAllowed) {
		return <Navigate to={paths.home} replace />;
	}

	return <>{children}</>;
};
